import { BlockCategoryType } from './types'

export const blockCategories = {
  pageFooters: 'pageFooters',
  pageHeaders: 'pageHeaders',
  teamMembers: 'teamMembers',
  orderForms: 'orderForms',
  testimonials: 'testimonials',
  pricePlans: 'pricePlans',
  features: 'features',
  optInForms: 'optInForms',
  hero: 'hero',
  surveys: 'surveys',
  userMaster: 'userMaster',
  userSimple: 'userSimple',
  user: 'user',
} as const

export const blockCategoryNames: Record<BlockCategoryType, string> = {
  [blockCategories.testimonials]: 'components.core.blocks.common.testimonials',
  [blockCategories.pricePlans]: 'components.core.blocks.common.price_plans',
  [blockCategories.features]: 'components.core.blocks.common.features',
  [blockCategories.optInForms]: 'components.core.blocks.common.opt_in_forms',
  [blockCategories.pageFooters]: 'components.core.blocks.common.page_footers',
  [blockCategories.pageHeaders]: 'components.core.blocks.common.page_headers',
  [blockCategories.teamMembers]: 'components.core.blocks.common.team_members',
  [blockCategories.orderForms]: 'components.core.blocks.common.order_forms',
  [blockCategories.hero]: 'components.core.blocks.common.hero',
  [blockCategories.surveys]: 'components.core.blocks.common.surveys',
  [blockCategories.userMaster]:
    'components.core.blocks.groups.user_blocks.master',
  [blockCategories.userSimple]:
    'components.core.blocks.groups.user_blocks.simple',
  [blockCategories.user]: 'components.core.blocks.groups.user_blocks.title',
} as const
